import { useSchoolLogo } from '../hooks/useSchoolLogo'

interface SchoolLogoProps {
  height?: string
  width?: string
  style?: React.CSSProperties
  className?: string
  alt?: string
}

export function SchoolLogo({ 
  height = '40px', 
  width = 'auto', 
  style = {},
  className = '',
  alt = 'ISŠ Cheb Logo'
}: SchoolLogoProps) {
  const logoUrl = useSchoolLogo()

  return (
    <img 
      src={logoUrl} 
      alt={alt} 
      style={{ height, width, ...style }}
      className={className}
      onError={(e) => {
        // Если логотип не загружается, используем дефолтный SVG через data URI
        const fallbackSvg = 'data:image/svg+xml;base64,' + btoa('<?xml version="1.0" encoding="UTF-8"?><svg width="200" height="200" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"><circle cx="100" cy="100" r="90" fill="#14b8a6"/><text x="100" y="120" font-family="Arial, sans-serif" font-size="60" font-weight="bold" fill="white" text-anchor="middle">ISŠ</text><text x="100" y="150" font-family="Arial, sans-serif" font-size="20" fill="white" text-anchor="middle">Cheb</text></svg>')
        if (e.currentTarget.src !== fallbackSvg) {
          e.currentTarget.src = fallbackSvg
        }
      }}
    />
  )
}

